document.addEventListener("DOMContentLoaded", function () {
	function checkCartItems() {
		const cartItemNames = document.querySelectorAll('.cart-item__name');
		const uniqueNames = new Set();

		cartItemNames.forEach(item => {
			uniqueNames.add(item.textContent.trim());
		});

		const checkoutButton = document.querySelector('#checkout');
		const errorMessage = document.querySelector('#cart_error_message');
		if (checkoutButton && errorMessage) {
			if (uniqueNames.size > 1) {
				checkoutButton.setAttribute('disabled', 'true');
				checkoutButton.classList.add('disable');
				errorMessage.style.display = 'block';
			} else {
				checkoutButton.removeAttribute('disabled');
				checkoutButton.classList.remove('disable');
				errorMessage.style.display = 'none';
			}
		}
	}

	// 初期ロード時にカートアイテムをチェック
	checkCartItems();

	// ShopifyのAjaxリクエストが完了した後にカートを更新するカスタムイベントを作成
	$(document).ajaxComplete(function (event, xhr, settings) {
		if (settings.url.includes('/cart')) {
			document.dispatchEvent(new Event('cart:updated'));
		}
	});

	// カートが更新されたときにチェックを行う
	document.addEventListener('cart:updated', function () {
		checkCartItems();
	});
});